"use client";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { FreeMode, Navigation, Pagination } from 'swiper/modules';
import SmiliaruniCard from './similaruni-card';

interface NonadvertSimilaruniProps {
  featuredProviders: any;
  slug: any;
  id?: string;
  isPostgraduate?:any;
}

const NonadvertSimilaruni = ({ featuredProviders, slug, id ,isPostgraduate }: NonadvertSimilaruniProps) => {
  return (
    <div className="slider-container" id={id ?? "similar-unis"}>
      <Swiper
        pagination={{ clickable: true }}
        navigation={true}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
        modules={[FreeMode, Pagination, Navigation]}
        className={`MultiSwiper elite-carousal ${featuredProviders?.length <= 2 ? 'nonAdvertSwiperMob' : featuredProviders?.length === 3 ? 'nonAdvertSwiper' : ''}`}>
        {featuredProviders?.map((uni: any, index: any) =>
          <SwiperSlide>
            <SmiliaruniCard uniInfo={uni} index={index} slug={slug} isPostgraduate={isPostgraduate}/>
          </SwiperSlide>)
        }
      </Swiper>
    </div>
  )
}

export default NonadvertSimilaruni;